/**
* 门禁
*/
const doorControl = {
  
getDoorControlRecords: "/api/getDoorControlRecords",//查询
getDoorControlRecords2: "/api/getDoorControlRecords2",//查询
}

export default doorControl